import { OP_STATUS } from "../../../../../util/varibles/constants";
import Icon, { ICON_NAME } from "../../../../Icon";

export function Approve({ approver, status }: { approver?: string, status?: OP_STATUS }) {
    if (!approver)
        return null;

    return <div className='flex items-center gap-1'>
        <div className='flex items-center'>
            <Icon icon={ICON_NAME.SPOT} size={32} style={{ background: '#56A513' }} />
            <span>:</span>
        </div>
        <div className='text-[15px]'>{approver + (status === OP_STATUS.CANCELED ? ' canceled' : ' approved')}</div>
    </div>
}